module.exports = __webpack_public_path__ + "img/t-shirt.f80e67f8.svg";